import { ResponsiveBreak } from 'src/components';
import { Typography } from '@mui/material';
import { JobOpeningCrucialRequirementCategory } from 'src/types';

export const Subheader: React.FC<{
  category: JobOpeningCrucialRequirementCategory;
}> = ({ category }) => {
  if (
    [
      JobOpeningCrucialRequirementCategory.DomainKnowledge,
      JobOpeningCrucialRequirementCategory.Technology,
    ].includes(category)
  ) {
    return (
      <Typography>
        Some of our open positions <b>require experience</b> in these
        technologies <ResponsiveBreak breakpoint="xs" /> or domains. Please
        select which ones match your skill set.
      </Typography>
    );
  }

  if (JobOpeningCrucialRequirementCategory.Education === category) {
    return (
      <Typography>
        Some of our positions or clients{' '}
        <b>require specific educational qualifications</b>.
        <ResponsiveBreak breakpoint="xs" />
        Could you please specify your educational background?
      </Typography>
    );
  }

  if (JobOpeningCrucialRequirementCategory.Visa === category) {
    return (
      <Typography>
        We are unable to sponsor or take over sponsorship of an employment visa
        at this time. <ResponsiveBreak breakpoint="xs" />
        Please specify if you have one.
      </Typography>
    );
  }

  if (JobOpeningCrucialRequirementCategory.WorkingConditions === category) {
    return (
      <Typography>
        Some of our positions or clients require certain working conditions,
        such as a specific time zone overlap or the need to attend the office.{' '}
        <ResponsiveBreak breakpoint="xs" />
        Please select the options that apply to your situation.
      </Typography>
    );
  }

  return null;
};
